import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import appConfig from "../../config/app.config";
import "./Error.css";

function ErrorNotFound({ header, description, btnTxt }) {
  const navigate = useNavigate();
  const isAccessDenied = header === "Access Denied";

  return (
    <section className="error">
      <div className="error-card">
        <div className="error-icon" aria-hidden="true" data-testid="error-icon">
          {isAccessDenied ? <LockOutlinedIcon /> : <ErrorOutlineIcon />}
        </div>
        <p className="error-eyebrow">QC E-PAYMENT</p>
        <h1 className="error-heading">{header}</h1>
        <p className="error-description">{description}</p>
        {!!btnTxt && (
          <Button
            onClick={() => navigate(appConfig.app.subDir)}
            className="error-action"
            variant="contained"
            size="large"
            disableElevation
            data-testid="error-action-button"
          >
            {btnTxt}
          </Button>
        )}
      </div>
    </section>
  );
}

ErrorNotFound.propTypes = {
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  btnTxt: PropTypes.string,
};

ErrorNotFound.defaultProps = {
  btnTxt: "",
};

export default ErrorNotFound;
